import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import rules from '../../common/rules/rules';
import SmsResendControl from './SmsResendControl';

@translate()
@Form.create()
export default class ConfirmLoanAllocationModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    hideModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onResendSmsCode: PropTypes.func.isRequired,
    resendCooldownKey: PropTypes.string,
    isAllocation: PropTypes.bool,
  };

  handleSubmit = () => {
    const { form, onSubmit } = this.props;

    form.validateFields((err, { token }) => {
      if (!err) {
        onSubmit(token);
      }
    });
  };

  render() {
    const { isLoading, hideModal, form, t, isAllocation, onResendSmsCode, resendCooldownKey } = this.props;
    const { getFieldDecorator } = form;

    const title = isAllocation ? t('Potvrdenie novej investície') : t('Potvrdenie novej pôžičky');
    const resendHelp = (
      <SmsResendControl
        t={t}
        onResendSmsCode={onResendSmsCode}
        resendCooldownKey={resendCooldownKey}
      />
    );

    return (
      <Modal
        visible
        confirmLoading={isLoading}
        title={title}
        onOk={this.handleSubmit}
        onCancel={hideModal}
        okText={t('Odoslať')}
      >
        <Form>
          <Form.Item help={resendHelp}>
            {getFieldDecorator('token', { rules: rules.required })(
              <Input size="default" placeholder={t('Kód SMS správy')} />
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/ConfirmLoanAllocationModal.js